import * as React from 'react'
import * as API from './lib/api'
import { PurchaseOption } from './lib/purchase_option'

interface IProps {
  purchaseOptions: PurchaseOption[]
  selectedPurchaseOptionName: API.PurchaseOptionNameType
  onPurchaseOptionChange: (newPurchaseOptionName: API.PurchaseOptionNameType) => void
}

export class PurchaseOptionsSelect extends React.Component<IProps, {}> {
  public render() {
    const { selectedPurchaseOptionName } = this.props
    const { purchaseOptions } = this.props

    return (
      <select
        onChange={this.onChange}
        style={{ display: 'block' }}
        value={selectedPurchaseOptionName}
      >
        {purchaseOptions.map((o) => this.renderPurchaseOption(o))}
      </select>
    )
  }

  private onChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const { onPurchaseOptionChange } = this.props
    const selectedName = e.currentTarget.value as API.PurchaseOptionNameType

    onPurchaseOptionChange(selectedName)
  }

  private renderPurchaseOption(purchaseOption: PurchaseOption) {
    const { membershipPlan: plan, paymentDetails } = purchaseOption

    return (
      <option
        key={purchaseOption.name}
        value={purchaseOption.name}
      >
        {plan.name} Membership - {paymentDetails.paymentTerm} of ${paymentDetails.basePrice}
      </option>
    )
  }
}
